import { withStyles } from '@material-ui/core';

import HeadRow from './component';
import styles from './styles';

export default withStyles(styles)(HeadRow);
